module.exports = __webpack_public_path__ + "img/dz.d98291bf.svg";